import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const PlusCircled = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M8 5V11M5 8H11" stroke={color} strokeLinecap="round" />
        <circle cx="8" cy="8" r="6.5" stroke={color} />
      </svg>
    )
  },
)

export default PlusCircled
